import * as api from '../connectivity/api.assignments';
import { call, put } from 'redux-saga/effects';
import { takeLatest, takeEvery } from 'redux-saga';
import * as types from '../constants/actionTypes';
import { browserHistory } from 'react-router';
import { showLoading, hideLoading } from 'react-redux-loading-bar';

import { spaceToUnderscore } from '../helpers/helpers';


export function* doRequestAssignments(action) {
    yield put(showLoading());

    try {
        yield put({
            type: types.REQUEST__STARTED,
            payload: {
                requestFrom: 'assignments.doRequestAssignments'
            }
        });

        const assignments = yield call(api.fetchAssignments);

        yield put({
            type: types.ASSIGNMENTS__REQUESTED__SUCCEEDED,
            payload: { assignments },
        });
    } catch (e) {
        yield put({
            type: types.ASSIGNMENTS__REQUESTED__FAILED,
            message: e.message
        });
    }
    yield put({
        type: types.REQUEST__FINISHED,
        payload: {
            requestFrom: 'assignments.doRequestAssignments'
        }
    });

    yield put(hideLoading());
}

export function* doRequestAssignmentsSucceeded(action) {
    yield put({
        type: types.REQUEST__SUCCEEDED,
        payload: {
            requestFrom: 'assignments.doRequestAssignments'
        }
    });
}

export function* doRequestAssignmentsFailed(action) {
    yield put({
        type: types.REQUEST__FAILED,
        payload: {
            requestFrom: 'assignments.doRequestAssignments'
        }
    });
}

export function* doRequestDropboxAssignment(action) {
    yield put(showLoading());

    yield put({
        type: types.REQUEST__STARTED,
        payload: {
            requestFrom: 'assignments.doRequestDropboxAssignment'
        }
    });

    try {
        const { assignmentName, dropboxName } = action.payload,
            assignment = yield call(api.fetchDropboxAssignment, dropboxName, assignmentName)
        ;

        yield put({
            type: types.DROPBOX__ASSIGNMENT__REQUESTED__SUCCEEDED,
            payload: { assignment }
        });
    } catch (e) {
        yield put({
            type: types.DROPBOX__ASSIGNMENT__REQUESTED__FAILED,
            message: e.message
        });
    }

    yield put({
        type: types.REQUEST__FINISHED,
        payload: {
            requestFrom: 'assignments.doRequestDropboxAssignment'
        }
    });

    yield put(hideLoading());
}

export function* doRequestDropboxAssignmentSucceeded(action) {
    yield put({
        type: types.REQUEST__SUCCEEDED,
        payload: {
            requestFrom: 'assignments.doRequestDropboxAssignment'
        }
    });
}

export function* doRequestDropboxAssignmentFailed(action) {
    const { message } = action.message;

    yield put({
        type: types.ADD_NOTIFICATION,
        payload: {
            message: `Error: unable to fetch assignment. ${message}`,
            level: 'error'
        }
    });

    yield put({
        type: types.REQUEST__FAILED,
        payload: {
            requestFrom: 'assignments.doRequestDropboxAssignments'
        }
    });

    browserHistory.push('/');
}

export function* doRequestCreateAssignment(action) {
    yield put(showLoading());

    try {
        yield put({
            type: types.REQUEST__STARTED,
            payload: {
                requestFrom: 'assignments.doRequestCreateAssignment'
            }
        });

        const assignment = yield call(api.createAssignment, action.payload.assignment);

        yield put({
            type: types.ASSIGNMENT__CREATE__REQUESTED__SUCCEEDED,
            payload: { assignment }
        });
    } catch (e) {
        yield put({
            type: types.ASSIGNMENT__CREATE__REQUESTED__FAILED,
            message: e.message
        });
    }

    yield put({
        type: types.REQUEST__FINISHED,
        payload: {
            requestFrom: 'assignments.doRequestCreateAssignment'
        }
    });

    yield put(hideLoading());
}

export function* doRequestCreateAssignmentSucceeded(action) {
    const { assignment } = action.payload,
        { dropbox } = assignment
    ;

    yield put({
        type: types.ADD_NOTIFICATION,
        payload: {
            message: `Assignment: ${assignment.name} created successfully`,
            level: 'success'
        }
    });

    yield put({
        type: types.REQUEST__SUCCEEDED,
        payload: {
            requestFrom: 'assignments.doRequestCreateAssignment'
        }
    });

    //redirect to home page and auto expand dropbox with new assignment
    browserHistory.push(`/?expand=${dropbox.id}`);
}

export function* doRequestCreateAssignmentFailed(action) {
    const { message } = action.message;

    yield put({
        type: types.ADD_NOTIFICATION,
        payload: {
            message: `Error: failed creating assignment. ${message}`,
            level: 'error'
        }
    });

    yield put({
        type: types.REQUEST__FAILED,
        payload: {
            requestFrom: 'assignments.doRequestCreateAssignment'
        }
    });
}

export function* doRequestUpdateAssignment(action) {
    const { assignmentName, dropboxName, reload } = action.payload;

    yield put(showLoading());

    try{
        yield put({
            type: types.REQUEST__STARTED,
            payload: {
                requestFrom: 'assignments.doRequestUpdateAssignment'
            }
        });

        const assignment = yield call(api.updateAssignment, action.payload.assignment);

        yield put({
            type: types.ASSIGNMENT__UPDATE__REQUESTED__SUCCEEDED,
            payload: { assignment, assignmentName, dropboxName }
        });
    } catch (e) {
        yield put({
            type: types.ASSIGNMENT__UPDATE__REQUESTED__FAILED,
            message: e.message
        });
    }

    yield put({
        type: types.REQUEST__FINISHED,
        payload: {
            requestFrom: 'assignments.doRequestUpdateAssignment'
        }
    });

    yield put(hideLoading());

    if (reload) {
        browserHistory.push(`/${dropboxName}/${spaceToUnderscore(assignmentName)}/edit`);
    }
}

export function* doRequestUpdateAssignmentSucceeded(action) {
    const { assignmentName, dropboxName } = action.payload;

    yield put({
        type: types.ADD_NOTIFICATION,
        payload: {
            message: `Assignment: ${assignmentName} updated successfully`,
            level: 'success'
        }
    });

    yield put({
        type: types.REQUEST__SUCCEEDED,
        payload: {
            requestFrom: 'assignments.doRequestUpdateAssignment'
        }
    });
}

export function* doRequestUpdateAssignmentFailed(action) {
    const { message } = action.message;

    yield put({
        type: types.ADD_NOTIFICATION,
        payload: {
            message: `Error: failed to update assignment. ${message}`,
            level: 'error'
        }
    });

    yield put({
        type: types.REQUEST__FAILED,
        payload: {
            requestFrom: 'assignments.doRequestUpdateAssignment'
        }
    });
}

export function* doRequestDeleteAssignment(action) {
    yield put(showLoading());

    try{
        yield put({
            type: types.REQUEST__STARTED,
            payload: {
                requestFrom: 'assignments.doRequestDeleteAssignment'
            }
        });

        const { payload } = action,
            { assignmentId, dropboxId } = payload
        ;

        yield call(api.deleteAssignment, assignmentId);

        yield put({
            type: types.ASSIGNMENT__DELETE__REQUESTED__SUCCEEDED,
            payload: { assignmentId, dropboxId },
        });
    } catch (e) {
        yield put({
            type: types.ASSIGNMENT__DELETE__REQUESTED__FAILED,
            message: e.message
        });
    }

    yield put({
        type: types.REQUEST__FINISHED,
        payload: {
            requestFrom: 'assignments.doRequestDeleteAssignment'
        }
    });

    yield put(hideLoading());
}

export function* doRequestDeleteAssignmentSucceeded(action) {
    const { dropboxId } = action.payload;

    yield put({
        type: types.ADD_NOTIFICATION,
        payload: {
            message: "Assignment deleted successfully",
            level: 'success'
        }
    });

    yield put({
        type: types.REQUEST__SUCCEEDED,
        payload: {
            requestFrom: 'assignments.doRequestDeleteAssignment'
        }
    });

    //redirect to home page and auto expand dropbox
    browserHistory.push('/?expand='+dropboxId);
}

export function* doRequestDeleteAssignmentFailed(action) {
    const { message } = action.message;

    yield put({
        type: types.ADD_NOTIFICATION,
        payload: {
            message: `Error: failed to delete assignment. ${message}`,
            level: 'error'
        }
    });

    yield put({
        type: types.REQUEST__FAILED,
        payload: {
            requestFrom: 'assignments.doRequestDeleteAssignment'
        }
    });
}

export function* doRequestCopyAssignment(action) {
    yield put(showLoading());

    try {
        yield put({
            type: types.REQUEST__STARTED,
            payload: {
                requestFrom: 'assignments.doRequestCopyAssignment'
            }
        });

        const { assignmentId, dropboxId } = action.payload,
            assignment = yield call(api.copyAssignment, assignmentId, dropboxId)
        ;

        yield put({
            type: types.ASSIGNMENT__COPY__REQUESTED__SUCCEEDED,
            payload: { assignment }
        });
    } catch (e) {
        yield put({
            type: types.ASSIGNMENT__COPY__REQUESTED__FAILED,
            message: e.message
        });
    }

    yield put({
        type: types.REQUEST__FINISHED,
        payload: {
            requestFrom: 'assignments.doRequestCopyAssignment'
        }
    });

    yield put(hideLoading());
}

export function* doRequestCopyAssignmentSucceeded(action) {
    const { assignment } = action.payload;

    yield put({
        type: types.ADD_NOTIFICATION,
        payload: {
            message: `Assignment: ${assignment.name} copied successfully`,
            level: 'success'
        }
    });

    yield put({
        type: types.REQUEST__SUCCEEDED,
        payload: {
            requestFrom: 'assignments.doRequestCopyAssignment'
        }
    });

    //redirect to new assignment
    browserHistory.push(`/${assignment.dropbox.name}/${spaceToUnderscore(assignment.name)}/edit`);
}

export function* doRequestCopyAssignmentFailed(action) {
    const { message } = action;

    yield put({
        type: types.ADD_NOTIFICATION,
        payload: {
            message: `Error: failed to copy assignment. ${message}`,
            level: 'error'
        }
    });

    yield put({
        type: types.REQUEST__FAILED,
        payload: {
            requestFrom: 'assignments.doRequestCopyAssignment'
        }
    });
}

export function* doRequestCopyAssignments(action) {
    yield put(showLoading());

    try{
        yield put({
            type: types.REQUEST__STARTED,
            payload: {
                requestFrom: 'assignments.doRequestCopyAssignments'
            }
        });

        const { sourceDropboxId, destinationDropboxId } = action.payload,
            assignments = yield call(api.copyAllAssignments, sourceDropboxId, destinationDropboxId)
        ;

        yield put({
            type: types.ASSIGNMENTS__COPY__REQUESTED__SUCCEEDED,
            payload: { assignments, destinationDropboxId }
        });
    } catch (e) {
        yield put({
            type: types.ASSIGNMENTS__COPY__REQUESTED__FAILED,
            message: e.message
        });
    }

    yield put({
        type: types.REQUEST__FINISHED,
        payload: {
            requestFrom: 'assignments.doRequestCopyAssignments'
        }
    });

    yield put(hideLoading());
}

export function* doRequestCopyAssignmentsSucceeded(action) {
    const { destinationDropboxId } = action.payload;

    yield put({
        type: types.ADD_NOTIFICATION,
        payload: {
            message: "All assignments copied successfully",
            level: 'success'
        }
    });

    yield put({
        type: types.REQUEST__SUCCEEDED,
        payload: {
            requestFrom: 'assignments.doRequestCopyAssignments'
        }
    });

    //redirect to home and expand destination dropbox
    browserHistory.push(`/?expand=${destinationDropboxId}`);
}

export function* doRequestCopyAssignmentsFailed(action) {
    yield put({
        type: types.ADD_NOTIFICATION,
        payload: {
            message: "Error: could not copy assignments.",
            level: 'error'
        }
    });

    yield put({
        type: types.REQUEST__FAILED,
        payload: {
            requestFrom: 'assignments.doRequestCopyAssignments'
        }
    });
}

export function* watchRequestAssignments() {
    yield* takeLatest(types.ASSIGNMENTS__REQUESTED, doRequestAssignments);
}

export function* watchRequestAssignmentsSucceeded() {
    yield* takeLatest(types.ASSIGNMENTS__REQUESTED__SUCCEEDED, doRequestAssignmentsSucceeded);
}

export function* watchRequestAssignmentsFailed() {
    yield* takeLatest(types.ASSIGNMENTS__REQUESTED__FAILED, doRequestAssignmentsFailed);
}

export function* watchRequestCreateAssignment() {
    yield* takeLatest(types.ASSIGNMENT__CREATE__REQUESTED, doRequestCreateAssignment);
}

export function* watchRequestCreateAssignmentSucceeded() {
    yield* takeLatest(types.ASSIGNMENT__CREATE__REQUESTED__SUCCEEDED, doRequestCreateAssignmentSucceeded);
}

export function* watchRequestCreateAssignmentFailed() {
    yield* takeLatest(types.ASSIGNMENT__CREATE__REQUESTED__FAILED, doRequestCreateAssignmentFailed);
}

export function* watchRequestUpdateAssignment() {
    yield* takeLatest(types.ASSIGNMENT__UPDATE__REQUESTED, doRequestUpdateAssignment);
}

export function* watchRequestUpdateAssignmentSucceeded() {
    yield* takeLatest(types.ASSIGNMENT__UPDATE__REQUESTED__SUCCEEDED, doRequestUpdateAssignmentSucceeded);
}

export function* watchRequestUpdateAssignmentFailed() {
    yield* takeLatest(types.ASSIGNMENT__UPDATE__REQUESTED__FAILED, doRequestUpdateAssignmentFailed);
}

export function* watchRequestDeleteAssignment() {
    yield* takeEvery(types.ASSIGNMENT__DELETE__REQUESTED, doRequestDeleteAssignment);
}

export function* watchRequestDeleteAssignmentSucceeded() {
    yield* takeEvery(types.ASSIGNMENT__DELETE__REQUESTED__SUCCEEDED, doRequestDeleteAssignmentSucceeded);
}

export function* watchRequestDeleteAssignmentFailed() {
    yield* takeLatest(types.ASSIGNMENT__DELETE__REQUESTED__FAILED, doRequestDeleteAssignmentFailed);
}

export function* watchRequestCopyAssignment() {
    yield* takeLatest(types.ASSIGNMENT__COPY__REQUESTED, doRequestCopyAssignment);
}

export function* watchRequestCopyAssignmentSucceeded() {
    yield* takeLatest(types.ASSIGNMENT__COPY__REQUESTED__SUCCEEDED, doRequestCopyAssignmentSucceeded);
}

export function* watchRequestCopyAssignmentFailed() {
    yield* takeLatest(types.ASSIGNMENT__COPY__REQUESTED__FAILED, doRequestCopyAssignmentFailed);
}

export function* watchRequestCopyAssignments() {
    yield* takeLatest(types.ASSIGNMENTS__COPY__REQUESTED, doRequestCopyAssignments);
}

export function* watchRequestCopyAssignmentsSucceeded() {
    yield* takeLatest(types.ASSIGNMENTS__COPY__REQUESTED__SUCCEEDED, doRequestCopyAssignmentsSucceeded);
}

export function* watchRequestCopyAssignmentsFailed() {
    yield* takeLatest(types.ASSIGNMENTS__COPY__REQUESTED__FAILED, doRequestCopyAssignmentsFailed);
}

export function* watchRequestDropboxAssignment() {
    yield* takeLatest(types.DROPBOX__ASSIGNMENT__REQUESTED, doRequestDropboxAssignment);
}

export function* watchRequestDropboxAssignmentSucceeded() {
    yield* takeLatest(types.DROPBOX__ASSIGNMENT__REQUESTED__SUCCEEDED, doRequestDropboxAssignmentSucceeded);
}

export function* watchRequestDropboxAssignmentFailed() {
    yield* takeLatest(types.DROPBOX__ASSIGNMENT__REQUESTED__FAILED, doRequestDropboxAssignmentFailed);
}



/** WEBPACK FOOTER **
 ** ./src/sagas/assignments.saga.js
 **/